export enum ServiceStatus {
  InAuction = 'InAuction',
  ManualHandled = 'ManualHandled',
  InMarket = 'InMarket',
  Assigned = 'Assigned',
  Unassigned = 'Unassigned',
  Started = 'Started',
  Aborted = 'Aborted',
  Completed = 'Completed',
  Canceled = 'Canceled'
}
